import LinearProgress from "@mui/material/LinearProgress";
import React from "react";
import styled from "styled-components";
import { useAppSelector } from "../../app/hooks";
import { deliveryState } from "../../app/reducers/delivery-slice";
import { scheduleState } from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import { DeliveryStatus } from "../../types/delivery/delivery-status";

interface Props {
  isFetching: boolean;
}

export const WaitDeliveryList: React.FC<Props> = ({ isFetching }) => {
  const { dateToWork } = useAppSelector(scheduleState);
  const { deliveryPage } = useAppSelector(deliveryState);
  const deliveriesOnDate = deliveryPage.contents.filter((delivery) => {
    return delivery.dateToWork === dateToWork;
  });

  const waitDeliveryCount = deliveriesOnDate.filter(
    (delivery) => delivery.status === DeliveryStatus.Wait
  ).length;

  const totalDeliveryCount = deliveriesOnDate.length;

  return (
    <WaitDeliveryListContainer>
      <WaitDeliveryListTitle>미등록 물류</WaitDeliveryListTitle>
      {!isFetching && (
        <WaitDeliveryListContent>
          {waitDeliveryCount}/{totalDeliveryCount}건
        </WaitDeliveryListContent>
      )}
      {isFetching && (
        <LoadingContainer>
          <LinearProgress
            color="inherit"
            sx={{
              width: "100%",
              color: theme.palette.primitives.yellow400,
            }}
          />
        </LoadingContainer>
      )}
    </WaitDeliveryListContainer>
  );
};

const WaitDeliveryListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 24px;
  white-space: nowrap;
`;

const WaitDeliveryListTitle = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: ${theme.palette.primitives.gray600};
`;

const WaitDeliveryListContent = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: ${theme.palette.primitives.gray900};
`;

const LoadingContainer = styled.div`
  padding-top: 18px;
`;
